import { render, staticRenderFns } from "./DecaySpark.vue?vue&type=template&id=5bd51929&"
import script from "./DecaySpark.vue?vue&type=script&lang=js&"
export * from "./DecaySpark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports